export var PACKAGE_SOURCE = "components";
export var PACKAGE_VERSION = "3.0.0 (1b71d6c1)";
export var GIT_SHA = "1b71d6c1";
export var THEME = "polaris";
export var SYSTEM = "console";
export var ALWAYS_VISUAL_REFRESH = false;